module.exports = __webpack_public_path__ + "static/Załącznik nr 1 do REGULAMINU-9205dc2ee9690199158721c3482a50e9.pdf";